import React from 'react'
import dynamic from 'next/dynamic'
import Image from 'next/image'
import Link from 'next/link'
import Footer from '../../components/home/footer'
import { ResourcesList } from '@utils/resourcesList'
import TestimonialBar from '@/components/home/testimonialBar'
import AppDetails from '@/components/home/appDetails'
import CTA from '@/components/cta'
import ColorMutedImg from '@images/header-bg/color-muted.webp'
import Seo from '@/components/seo'

const Header = dynamic(
  () => import('../../components/header'),
  { ssr: false }
)

const Resources = () => {

  return (
    <div className="">
      <Seo
        title="Free Resources | Pinto Financial"
        description="See How Our Free Resources Can Get You Pointed In The Right Direction. Pinto Has Financial Templates That Fit Every Need."
      />

      <Header />

      <div className="relative bg-white max-w-7xl mx-auto px-4 sm:px-6 py-8  -mb-32">

        {/* Resrouces Header */}
        <div className="mx-auto max-w-7xl mt-12">
          <div className="relative overflow-hidden bg-gray-900 py-20 px-6 border sm:rounded-xl sm:py-24 sm:px-10 md:px-12 lg:px-20 transition shadow-[0_1px_3px_rgba(15,23,42,0.03),0_1px_2px_rgba(15,23,42,0.06)] ring-1 ring-slate-600/[0.04] ">
            <Image
              className="absolute inset-0 h-full w-full object-cover"
              src={ColorMutedImg} 
              priority 
              alt=""
            />
            <div className="relative mx-auto max-w-2xl ">
              {/*<img className="h-12 w-auto" src="https://tailwindui.com/img/logos/workcation-logo-white.svg" alt="" />*/}
              <h2 className="text-4xl mb-6 text-gray-900 text-center">Pinto&apos;s <span className='text-pinto-dark underline'>Free</span> Resources</h2>
              <figure>
                <blockquote className="mt-6 text-lg sm:text-xl sm:leading-8">
                  <p className="text-center">
                    We help small and medium sized businesses <br />make the best financial decisions
                  </p>
                </blockquote>
                
                {/*<figcaption className="mt-6 text-base text-white">
                  <div className="font-semibold">Judith Black</div>
                  <div className="mt-1">CEO of Tuple</div>
                  </figcaption>*/}
              </figure>
            </div>
          </div>
        </div> 


        {/* Resrouces Content */}
        <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-3">
          {ResourcesList.map((resource) => (
            <Link
              href={resource.href}
              key={resource.href}
              className="transition relative flex items-start space-x-3 rounded-lg border border-gray-300 bg-white px-6 py-5 shadow-sm hover:ring-2 hover:ring-pinto ring-offset-1 duration-500 hover:ring-x-pinto hover:ring-y-pinto-dark"
            >
              <div className="flex-shrink-0">
                <Image width={40} height={40} src={resource.thumbnail} alt={resource.title} unoptimized/>
              </div>
              <div className="min-w-0 flex-1">
                <span className="focus:outline-none">
                  <p className="text-sm font-medium text-gray-900 pb-2">{resource.title}</p>
                  <p className="text-sm text-gray-500">{resource.description}</p>
                </span>
                <p className="text-sm font-semibold leading-6 text-gray-900 text-right mt-4 hover:text-pinto">
                  Learn more <span aria-hidden="true">→</span>
                </p>    
              </div>
            </Link>
          ))}
        </div>

        <div className='text-center mt-24'>
          <h2 className="text-base font-semibold leading-7 text-pinto">Enjoying our free tools?</h2>
          <h1 className="mt-2 text-3xl font-medium tracking-tight text-gray-900 sm:text-4xl">
            Learn more about Pinto
          </h1>
        </div>
      </div>

      <TestimonialBar count={1} />
      <AppDetails />
      <CTA />

      <Footer />
    </div>
  )
}

export default Resources